module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-1127.5418deb5.jpg";